import React from 'react';
import { Spinner } from 'react-bootstrap';
import { ServicesContext } from '~/services';

interface DeletePhoneProps {
    cancel: () => void;
    edit: () => void;
    phoneId: number;
    onPhoneDelete?: (x: number) => void;
}
function DeletePhone({ cancel, edit, phoneId, onPhoneDelete }: DeletePhoneProps) {
    const servicesContext = React.useContext(ServicesContext);
    const [deleting, setDeleting] = React.useState(false);

    async function deletePhone() {
        setDeleting(true);
        await servicesContext.user.deletePhone(phoneId);
        onPhoneDelete?.(phoneId);
        setDeleting(false);
        edit();
    }

    return (
        <div className="row">
            <div className="col-12 text-center">
                <p>Are you sure? This phone number will not be usable for 2-step verification.</p>
                <button
                    className="btn btn-secondary me-2"
                    disabled={deleting}
                    onClick={cancel}
                    type="button"
                >
                    Cancel
                </button>
                <button
                    className="btn btn-danger"
                    disabled={deleting}
                    onClick={deletePhone}
                    type="button"
                >
                    {deleting && (
                        <Spinner
                            animation="border"
                            className="me-1"
                            role="status"
                            size="sm"
                            variant="light"
                        />
                    )}
                    Yes, Delete
                </button>
            </div>
        </div>
    );
}

export { DeletePhone };
